import type { TUserActionNotification } from "../reducers/dashboard";

export function addUserActionNotification(json: TUserActionNotification) {
  return { type: "ADD_USER_ACTION_NOTIFICATION", json } as const;
}

export function eraseUserActionNotification() {
  return { type: "ERASE_USER_ACTION_NOTIFICATION" } as const;
}
